import { render, staticRenderFns } from "./AttachModulesWizard.vue?vue&type=template&id=c85ffa88&scoped=true&"
import script from "./AttachModulesWizard.vue?vue&type=script&lang=ts&"
export * from "./AttachModulesWizard.vue?vue&type=script&lang=ts&"
import style0 from "./AttachModulesWizard.vue?vue&type=style&index=0&id=c85ffa88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85ffa88",
  null
  
)

export default component.exports